"use strict";
Object.defineProperty(exports, "__esModule", { value: true });
var EmailTemplatesActions;
(function (EmailTemplatesActions) {
    EmailTemplatesActions["DataLoaded"] = "DataLoaded";
})(EmailTemplatesActions || (EmailTemplatesActions = {}));
exports.default = EmailTemplatesActions;
